import React, { useState } from 'react';
import BearingAnalysis from '../components/PhysicsLab/BearingAnalysis';
import ElectricalAnalysis from '../components/PhysicsLab/ElectricalAnalysis';
import AeratorAnalysis from '../components/PhysicsLab/AeratorAnalysis';
import ControlsAnalysis from '../components/PhysicsLab/ControlsAnalysis';
import EvMotorAnalysis from '../components/PhysicsLab/EvMotorAnalysis';
import AltAnalysis from '../components/PhysicsLab/AltAnalysis';
import FatigueAnalysis from '../components/PhysicsLab/FatigueAnalysis';
import { Microscope, Zap, Settings, Wind, Sliders, Timer, Hammer, AlertTriangle } from 'lucide-react';
import ActiveProjectBadge from '../components/ActiveProjectBadge';

const PhysicsLab: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'bearing' | 'electrical' | 'aerator' | 'controls' | 'ev' | 'alt' | 'fatigue'>('bearing');

    return (
        <div className="space-y-6 animate-in fade-in duration-500">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-3xl font-bold text-text-primary flex items-center gap-2">
                        <Microscope className="text-primary" /> Physics Verification Lab
                    </h1>
                    <p className="text-text-secondary mt-1">
                        Validate design margins using industry-standard physics models (ISO, ASTM, SAE).
                    </p>
                </div>
                <ActiveProjectBadge showStandard={false} />
            </div>

            {/* Tab Navigation */}
            <div className="flex border-b border-border space-x-4 overflow-x-auto pb-1">
                <button
                    onClick={() => setActiveTab('bearing')}
                    className={`pb-2 px-1 flex items-center gap-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'bearing'
                        ? 'border-primary text-primary'
                        : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                        }`}
                >
                    <Settings size={16} /> Mechanical
                </button>
                <button
                    onClick={() => setActiveTab('electrical')}
                    className={`pb-2 px-1 flex items-center gap-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'electrical'
                        ? 'border-primary text-primary'
                        : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                        }`}
                >
                    <Zap size={16} /> Electrical
                </button>
                <button
                    onClick={() => setActiveTab('ev')}
                    className={`pb-2 px-1 flex items-center gap-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'ev'
                        ? 'border-primary text-primary'
                        : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                        }`}
                >
                    <AlertTriangle size={16} /> EV Safety
                </button>
                <button
                    onClick={() => setActiveTab('aerator')}
                    className={`pb-2 px-1 flex items-center gap-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'aerator'
                        ? 'border-primary text-primary'
                        : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                        }`}
                >
                    <Wind size={16} /> Aerator
                </button>
                <button
                    onClick={() => setActiveTab('controls')}
                    className={`pb-2 px-1 flex items-center gap-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'controls'
                        ? 'border-primary text-primary'
                        : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                        }`}
                >
                    <Sliders size={16} /> Controls
                </button>
                <button
                    onClick={() => setActiveTab('alt')}
                    className={`pb-2 px-1 flex items-center gap-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'alt'
                        ? 'border-primary text-primary'
                        : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                        }`}
                >
                    <Timer size={16} /> ALT
                </button>
                <button
                    onClick={() => setActiveTab('fatigue')}
                    className={`pb-2 px-1 flex items-center gap-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === 'fatigue'
                        ? 'border-primary text-primary'
                        : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                        }`}
                >
                    <Hammer size={16} /> Fatigue
                </button>
            </div>

            {/* Tab Content */}
            <div className="pt-4">
                {activeTab === 'bearing' && <BearingAnalysis />}
                {activeTab === 'electrical' && <ElectricalAnalysis />}
                {activeTab === 'ev' && <EvMotorAnalysis />}
                {activeTab === 'aerator' && <AeratorAnalysis />}
                {activeTab === 'controls' && <ControlsAnalysis />}
                {activeTab === 'alt' && <AltAnalysis />}
                {activeTab === 'fatigue' && <FatigueAnalysis />}
            </div>
        </div>
    );
};

export default PhysicsLab;
